require('./bootstrap');
require('./video_manager');


//автовебинары
$('[name="phone"]').on('change cut keyup paste', function(){
	let brs = $(this).val()[0] ?? false;
	if(brs!==false){
		if(brs!=="+"){
			$(this).parent().siblings('.attention_phone_number').css('display','inline-block');
		}else{
			$(this).parent().siblings('.attention_phone_number').hide();
		}
	}
});
$(document).ready(function () {
    $('button.vjs-big-play-button').each(function () {
        $(this).attr('title', '')
    })

    $('.js-menu-collapsible').on('mouseover', function (evt) {
        $(this).removeClass('js-menu-collapsed')
            .removeClass('col-lg-1')
            .addClass('col-lg-3');

        $('.js-container').removeClass('col-lg-11').addClass('col-lg-9');
    });
    $('.js-menu-collapsible').on('mouseout', function (evt) {
        $(this).addClass('js-menu-collapsed')
            .removeClass('col-lg-3')
            .addClass('col-lg-1');

        $('.js-container').removeClass('col-lg-9').addClass('col-lg-11');
    });
})

$(document).on('mousedown', function (e) {
    const el = $(e.target)
    if (el.hasClass('vjs-big-play-button')) {
        $(el).css({"background-size": "cover"})
    }
})

if ($('html').attr('lang') === 'ru') {
    window.lang = $.extend(window.lang||{}, {
        edit: 'Редактировать',
        deleteHead: 'Вы уверены?',
        deleteOk: 'Удалить',
        payOk: 'Оплатить',
        deleteCancel: 'Отменить',
        deleteBody: '',
        inviteHead: 'Вы уверены?',
        inviteOk: 'Отправить приглашения',
        inviteCancel: 'Отменить',
        inviteBody: 'Если вы подпишите аудиторию, то ученикам сразу будут отправлены письма приглашения. Вы уверены?',
        confirmWithPassword: 'Для подтверждения действия введите пароль',
        csrf_token_mismatch: `Пожалуйста обновите страницу и попробуйте заново`,
        error: `Произошла ошибка`,
        datepicker: {
            days: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
            daysShort: ['вск', 'пн', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
            daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
            months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
                'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
                'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            today: 'Сегодня'
        }
    });
} else {
    window.lang = $.extend(window.lang||{}, {
        edit: 'Edit',
        deleteHead: 'Are you sure?',
        deleteOk: 'Delete',
        payOk: 'Pay',
        deleteCancel: 'Cancel',
        deleteBody: '',
        inviteHead: 'Are you sure?',
        inviteOk: 'Send Invitations',
        inviteCancel: 'Cancel',
        inviteBody: 'If you invite the audience, invitation emails will immediately be sent to the students. Are you sure?',
        confirmWithPassword: 'To confirm this action, please enter your password',
        csrf_token_mismatch: `Please refresh the page and try again`,
        error: `An error occurred`,
        datepicker: {
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            months: ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Today'
        }
    });
}
setInterval(function () {
    $('.slide.active').animate({
        opacity: 0,
    }, 500, function () {
        $(this).removeClass('active');
        if ($(this).next().length) {
            $(this).next().addClass('active').animate({opacity: 1}, 1000);
        } else {
            $('.slides>.slide:first-child').addClass('active').animate({opacity: 1}, 1000);
        }
    });
}, 10000);
window.declOfNum = function (number, titles) {
    number = parseInt(number);
    cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}
window.number_format = function (number, decimals = 0, dec_point = '.', thousands_sep = ',') {

    let sign = number < 0 ? '-' : '';

    let s_number = Math.abs(parseInt(number = (+number || 0).toFixed(decimals))) + "";
    let len = s_number.length;
    let tchunk = len > 3 ? len % 3 : 0;

    let ch_first = (tchunk ? s_number.substr(0, tchunk) + thousands_sep : '');
    let ch_rest = s_number.substr(tchunk)
        .replace(/(\d\d\d)(?=\d)/g, '$1' + thousands_sep);
    let ch_last = decimals ?
        dec_point + (Math.abs(number) - s_number)
            .toFixed(decimals)
            .slice(2) :
        '';

    return sign + ch_first + ch_rest + (ch_last !== dec_point + '00' ? ch_last : '');
}
window.HELP_IMPROVE_VIDEOJS = false;
window.showAuthForm = function (params){
    if(!!params){
        if (params.hasOwnProperty('redirect_after')) {
            $('#modalAuth .social-auth a').each(function () {
                let href = $(this).attr('data-href').split('?'), url;
                url = href[0] + '?redirect_after=' + params.redirect_after;
                if (href.length > 1) {
                    url += '&' + href[1];
                }
                $(this).attr('href', url);
            });
            $('#modalAuth form').each(function () {
                let href = $(this).attr('data-action')||false, url;
                if(!href){
                    return;
                }
                href = href.split('?');
                url = href[0] + '?redirect_after=' + params.redirect_after;
                if (href.length > 1) {
                    url += '&' + href[1];
                }
                $(this).attr('action', url);
            });
        }
        if(params.hasOwnProperty('as_organizer')){
            $('#modalAuth').find('.modal-body:not(.hide)').addClass('hide');
            $('#modalAuth').find('.modal-body-reg').removeClass('hide');
            $('#modalAuth').find('.modal-body-reg .back').addClass('hide');
            $('#modalAuth').find('.modal-body-reg button[data-role="role2"]').trigger('click');
        }
    }
    $('#modalAuth').modal('show');
}
function initPhoneField(input){
    if(!input.hasAttribute('data-intl-tel-input-id')) {
        window.intlTelInput(input, {
            customContainer: 'lazyload',
            autoHideDialCode: false,
            utilsScript: "/assets/js/utils/intl-tel-input-utils.js",
            formatOnDisplay: false,
            initialCountry: "auto",
            geoIpLookup: function (callback) {
                callback(input.getAttribute('data-country'));
            },
            customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                input.value = input.value.trim();
                /*if (input.value.substr(0, (selectedCountryData.dialCode + '').length + 1) != '+' + selectedCountryData.dialCode) {
                    input.value = "+" + selectedCountryData.dialCode;
                } else {
                }*/
                return "+" + selectedCountryData.dialCode;
            },
        });
        input.setAttribute('init',1);
    }
}
$('.modal [type="phone"]').addClass('delay-init');
$('[type="phone"]:not(.delay-init)').each(function () {
    var input = $(this)[0];
    initPhoneField(input);
});
$('.modal').on('show.bs.modal',function (){
    $(this).find('[type="phone"]').each(function () {
        var input = $(this)[0];
        initPhoneField(input);
    });
});

function Form(link, data, options) { /* TODO: replace */
    const warningClass = 'is-invalid';
    const infoClass = 'is-valid';

    var configOptions = $.extend(true, {
        scrollToErrors: true
    }, options);

    var Link = link,
        instance = this,
        json = null;

    this.update = function (data) {
        if (data !== undefined) {
            json = data;
        }
        this.cleanMessages();

        if (!json) {
            return;
        }
        if (json.hasOwnProperty('clear')) {
            Link[0].reset();
        }
        if (json.hasOwnProperty('closeModal') && json.closeModal===true) {
            $('.modal.show').modal('hide');
        }
        if (json.hasOwnProperty('resetValues')) {
            $.each(json.resetValues, function (k, v) {
                $(v.selector).val(v.value).trigger('change');
            });
        }
        if (json.hasOwnProperty('thanksModal')) {
            Link.closest('.modal').find('.thanks').show().next().hide();
        }
        if (json.hasOwnProperty('errors')) {
            $.each(json.errors, function (k, v) {
                instance.addMessage(k, v, json.success);
            });
            if (json.errors.hasOwnProperty('common')) {
                swal({
                    text: json.errors.common.join(",\n"),
                    icon: 'error'
                }).then(function () {
                });
            }
            if(configOptions.scrollToErrors && $('.is-invalid').length){
                let offsetTop = $('.is-invalid:first').offset().top;
                if(!$('.is-invalid:first').is(":visible")){
                    if($('.is-invalid:first').closest('.form-group').is(":visible")){
                        offsetTop = $('.is-invalid:first').closest('.form-group').offset().top;
                    }else{
                        if($('.is-invalid').closest('.collapse:not(.show)').length){
                            $('.is-invalid').closest('.collapse:not(.show)').addClass('show');
                            offsetTop = $('.is-invalid:first').offset().top;
                        }
                    }
                }
                console.debug(offsetTop);
                $('html, body').animate({
                    scrollTop: offsetTop - 100
                }, 600);
            }
        }
        if (json.hasOwnProperty('messages')) {
            $.each(json.messages, function (k, v) {
                instance.addMessage(k, v, json.success);
            });
        }
        if (json.hasOwnProperty('message') && json.message === 'CSRF token mismatch.') {
            alert(lang.csrf_token_mismatch);
        }
        if (json.hasOwnProperty('redirect')) {
            window.location.href = json.redirect;
        }
        if (json.hasOwnProperty('fill')) {
            $(json.fill).each(function (k, fill) {
                $(fill.data).each(function (k, v) {
                    $(fill.selector).eq(k).val(v);
                });
            });
        }
		if (json.hasOwnProperty('updateCourse')) {
			console.debug('buggy',json);
			for (const [key, value] of Object.entries(json.updateCourse.data)) {
				console.debug(`${key}: ${value}`,$(`[name="lesson[id][${key}]"]`),`[name="lesson[id][${key}]"]`);
				$(`[name="lesson[id][${key}]"]`).val(value);
			}
        }
        if (json.hasOwnProperty('reload')) {
            window.location.reload();
        }

        if (json.hasOwnProperty('popup')) {
            swal({
                text: json.popup.text,
                icon: 'success'
            }).then(function () {
            });
        }
        if (json.hasOwnProperty('changeBtnText')) {
            Link.find('input[type=submit]').val(json.changeBtnText.text)
        }
        if (json.hasOwnProperty('waitRedirect')) {
            setTimeout(function () {
                window.location.href = json.waitRedirect;
            }, 2500);
        }
    };

    this.cleanMessages = function () {
        Link.find('.' + warningClass + ',.' + infoClass).each(function () {
            $(this).removeClass(warningClass);
            $(this).removeClass(infoClass);
            $(this).next('.valid-feedback,.invalid-feedback').remove();
            $(this).parent().removeClass(warningClass);
            $(this).parent().removeClass(infoClass);
            $(this).parent().next('.valid-feedback,.invalid-feedback').remove();
        });
    };
    this.clearMessage = function () {
        $(this).removeClass(warningClass);
        $(this).removeClass(infoClass);
        $(this).next('.valid-feedback,.invalid-feedback').remove();
        $(this).parent().removeClass(warningClass);
        $(this).parent().removeClass(infoClass);
        $(this).parent().next('.valid-feedback,.invalid-feedback').remove();
    };

    this.addMessage = function (name, messages, success) {
        var name_ = name.split('.');
        if (name_.length > 1 && parseInt(name_[name_.length - 1]) >= 0 && parseInt(name_[name_.length - 1]) <= 9) {
            name = name_[0];
            for (var i = 1; i < name_.length - 1; i++) {
                name += '[' + name_[i] + ']';
            }
            name += '[]';
            var input = Link.find('input[name="' + name + '"],input[data-name="' + name + '"],textarea[name="' + name + '"],select[name="' + name + '"]').eq(name_[name_.length - 1]);
        }
        if((typeof input === 'undefined' || !input.length) && name_.length > 1){
            var name =_.map(name_, function (v,k){
                if(k>0){
                    return '['+v+']';
                }else{
                    return v;
                }
            }).join('');
            var input = Link.find('input[name="' + name + '"],input[data-name="' + name + '"],textarea[name="' + name + '"],select[name="' + name + '"]');
        } else {
            var input = Link.find('input[name="' + name + '"],input[data-name="' + name + '"],textarea[name="' + name + '"],select[name="' + name + '"],[data-input-group="' + name + '"],[data-valid-name="' + name + '"]');
        }
        var parent = null, hideOnHover = false, form = this;
        if (name.indexOf('#') !== -1) {
            input = $(name);
            hideOnHover = true;
        }
        if (input.length) {
            var message = document.createElement('div');

            if ((typeof messages) === "object") {
                $.each(messages, function (k, v) {
                    message.innerHTML += '<span>' + v + '</span> ';
                });
                if (success) {
                    message.className = 'valid-feedback';
                    input.addClass(infoClass);
                    if ($(input).parent().hasClass('parent-error')) {
                        input.parent().addClass(infoClass);
                    }
                } else {
                    message.className = 'invalid-feedback';
                    input.addClass(warningClass);
                    if ($(input).parent().hasClass('parent-error')) {
                        input.parent().addClass(warningClass);
                    }
                }
                if ($(input).parent().hasClass('parent-error')) {
                    input.parent().next('.valid-feedback,.invalid-feedback').remove();
                    input.parent().after(message);
                } else if ($(input)[0].tagName === 'SELECT' && $(input).next('.select2').length) {
                    input.next('.select2').next('.valid-feedback,.invalid-feedback').remove();
                    input.next('.select2').after(message);
                } else if ($(input)[0].tagName === 'TEXTAREA' && $(input).next('.cke_editable').length) {
                    input.next('.cke_editable').next('.valid-feedback,.invalid-feedback').remove();
                    input.next('.cke_editable').after(message);
                } else {
                    input.next('.valid-feedback,.invalid-feedback').remove();
                    input.after(message);
                }
            }
            if (name === 'avatar') {
            } else {
                var events = {
                    keypress: form.clearMessage,
                    change: form.clearMessage,
                    focus: form.clearMessage,
                };
                if(input.is('[data-valid-name]')){
                    events = {click: form.clearMessage};
                }
                input.on(events);
                if (hideOnHover) {
                    input.hover(function () {
                    }, function () {
                        var self = $(this);
                        setTimeout(function () {
                            self.trigger('change');
                        }, 1500);
                    });
                }
            }
        } else {
            console.error('input: ' + name + ' not found');
        }
    }


    if (data != undefined) {
        json = data;
        this.update();
    }
};

$(function () {
    $(".header", ".toggleMenu").click(function() {
        $(this).closest(".toggleMenu").toggleClass('hide-in-mobile');
    });

    $("img.lazy").Lazy();
    $('form[data-ajax="1"] input[type="submit"], button[type="submit"]').click(function (e) {
        $(this).addClass('focusable');
    });
    $('form[data-ajax="1"]').submit(function (evt) {
        evt.preventDefault();

        var formOptions = {};
        if (typeof $(this).data('form-options') === 'object') {
            formOptions = $.extend(true, formOptions, $(this).data('form-options'));
        } else if (typeof $(this).data('form-options') !== 'undefined') {
            console.error('Form-options must be an Object!', this);
        }

        try {
            if(typeof CKEDITOR !== "undefined") {
                for (var instance in CKEDITOR.instances) {
                    // $.each(CKEDITOR.instances[instance].editable().find('.ckeditor-html5-videojs-modal-processed').$, function (key, value) {
                    //     $(value).remove();
                    // });

                    CKEDITOR.instances[instance].updateElement();
                }


                $('textarea.ckeditor').each(function () {
                    var $textarea = $(this);
                    var data = CKEDITOR.instances[$textarea.attr('name')].getData();
                    $textarea.val(data);

                });
            }
        }catch (e) {
            console.debug(e);
        }
        var sumbitter = $(this).find('input[type="submit"].focusable, button[type="submit"].focusable') || false;

        var action = $(this).attr('action');
        if(action.indexOf('?')>-1){
            action = action+'&_='+Math.random();
        }else{
            action = action+'?_='+Math.random();
        }
        var form = $(this);
        var data = form.serialize();

		if($('.course-form').find('[name="slider"]').length){
			let html_slider = $('.course-form').find('[name="slider"]').html();
			var cprr="";
			$('.course-form').find('[name="slider"] li').each(function(){
				cprr+=`src="${$(this).attr('src')}";`;
			});
			data+="&slider="+cprr;
		}
        if(sumbitter){
            sumbitter.removeClass('focusable');
            if((sumbitter.attr('data-action') || false)){
                action = sumbitter.data('action');
            }
            if ((sumbitter.attr('name') || false) && (sumbitter.attr('value') || false)) {
                data += '&' + sumbitter.attr('name') + '=' + sumbitter.attr('value');
            }
        }

        var showPreLoader = formOptions.hasOwnProperty('with_preloader')?formOptions.with_preloader:true;
        let buttonsend = $(this).find('button[type="submit"]'), buttontext = buttonsend.html();
        if(showPreLoader) {
            buttonsend.html('<img src="/assets/images/ajax-loader.gif">');
        }

		//console.log('bkleon', data);
      //  let url_string = window.location.href + '?' + data;
		//console.log('bkleon', url_string);
        //let url = new URL(url_string);
        let need_registration = data.match(/check_registration=1/ig)!==null ? true : false

        $.ajax({
            url: action,
            type: 'POST',
            data: data,
            dataType: 'JSON',
            cache: false,
            beforeSend: function (xhr, settings){
              typeof formOptions.beforeSend === 'function' &&  formOptions.beforeSend(xhr, settings, form);
            },
            success: function (data) {
                if (data.hasOwnProperty('save_message_to_localStorage') && data.hasOwnProperty('course_id')) {
                    localStorage.setItem('fast-message-' + data.course_id, JSON.stringify(
                        {
                            message: data.save_message_to_localStorage,
                            timestamp: new Date().getTime()
                        }
                    ));
                }

                new Form(form, data, formOptions);
                if(showPreLoader) {
                    buttonsend.html(buttontext);
                }

                if ((data.need_registration==null || data.need_registration==true) && need_registration) {
                    $('#modal_get_consultation').modal('show');
                }
            },
            error: function (xhr, textStatus, errorThrown ) {
                if (typeof formOptions.error === 'function' && formOptions.error(xhr, textStatus, errorThrown, form) === false) {
                    return;
                }
                new Form(form, xhr.responseJSON, formOptions);
                if(showPreLoader) {
                    buttonsend.html(buttontext);
                }
            },
            complete: function (xhr, textStatus){
                $('.hidden-btn').removeClass('d-none').removeClass('hidden-btn');
                $('.showed-spinner').addClass('d-none').removeClass('showed-spinner');
                if(showPreLoader) {
                    buttonsend.html(buttontext);
                }
                typeof formOptions.complete === 'function' && formOptions.complete(xhr, textStatus, form);
            }
        });

        return false;
    });

    $('.named-wrap > .pencil').click(function() {
        var $wrap = $(this).closest('.named-wrap');
        $wrap.addClass('editing');
        var $input = $wrap.find('input');
        $input.focus().on('blur', function(){
            saveName(this);
        });

        $input.on('keypress',function(e) {
            if(e.which == 13) {
                saveName(this);
            }
        });
    });

    function saveName(tt) {
        var $wrap = $(tt).closest('.named-wrap');
        var $input = $wrap.find('input')

        $.ajax({
            url: $wrap.data('url'),
            type: 'POST',
            data: {
                field: $wrap.data('field'),
                value: $input.val()
            },
            dataType: 'JSON',
            cache: false,
            success: function (data) {
                console.log('saved')
            },
            error: function (data) {
                console.log('error')
            }
        });
        $wrap.find('.value').html($input.val());
        $wrap.removeClass('editing')
    }

    $('.boxCrmTable .check-wrap').click(function() {
        var $checkboxx = $(this).find('input');
        $checkboxx.prop("checked", !$checkboxx.prop("checked"));

        if ( $(this).hasClass('th-check') ) {
            $('.boxCrmTable .td-check input').prop("checked", $checkboxx.prop("checked"))
        }

        $('.remove-selected-items').prop("disabled", $('.boxCrmTable .td-check input:checked').length === 0);
    });

    $('.boxCrmTable .th-check.check-wrap').click().click();

    $('.remove-selected-items').click(function() {
        var ids = [];
        var data = {
            ids: []
        };

        $('.boxCrmTable .td-check input:checked').each(function() {
            data.ids.push($(this).data('id'));
            $(this).closest('tr').remove();
        });
        if ($(this).data('webinarid')) {
            data.webinarid = $(this).data('webinarid');
            data.time = $(this).data('time');
            data.type = $(this).data('type');
        }

        $.ajax({
            url: $(this).data('url'),
            type: 'POST',
            data: data,
            dataType: 'JSON',
            cache: false,
            success: function (data) {
                console.log('deleted')
            },
            error: function (data) {
                console.log('error')
            }
        });
    });

    $('.crm__item .delete').click(function() {
        var _self = this;

        $.ajax({
            url: $(_self).data('url'),
            type: 'POST',
            dataType: 'JSON',
            cache: false,
            success: function (data) {
                $(_self).closest('.crm__table--mobile').remove();
                console.log('deleted')
            },
            error: function (data) {
                console.log('error')
            }
        });
    });


    $('.phone-img').click(function() {
        var $_sels = $(this),
            id = $_sels.closest('[data-id]').data('id');

        if ($_sels.hasClass('sending')) {
            return;
        }

        $_sels.closest('.phone-cont').find('.phone-img').addClass('d-none');
        $_sels.closest('.phone-cont').find('.spinner-call').removeClass('d-none').addClass('showed-spinner');

        $.ajax({
            url: '/zadarma-call' + ($_sels.data('user') ? '-user' : ''),
            type: 'POST',
            dataType: 'JSON',
            cache: false,
            data: {
                id: id
            },
            success: function (data) {
                console.log(data)
                setTimeout(function() {
                    $_sels.closest('.phone-cont').find('.phone-img').removeClass('d-none');
                    $_sels.closest('.phone-cont').find('.spinner-call').addClass('d-none');
                }, 6000);

            },
            error: function (data) {
                console.log('error')
                setTimeout(function() {
                    $_sels.closest('.phone-cont').find('.phone-img').removeClass('d-none');
                    $_sels.closest('.phone-cont').find('.spinner-call').addClass('d-none');
                }, 6000);
            }
        });
    });


    $('[data-modal-body]').click(function () {
        $(this).closest('.modal-content').find('.modal-body:not(.hide)').addClass('hide');
        $(this).closest('.modal-content').find('.' + $(this).data('modal-body') + ',.' + $(this).data('modal-body') + ' .back').removeClass('hide');
        return false;
    });
    if ($('[data-open="force"]').length) {
        $('#modalAuth').find('.modal-body:not(.hide)').addClass('hide');
        $('#modalAuth').find('.modal-body-forgot-final').removeClass('hide');
        $('#modalAuth').modal('show');
        // return false;
    }

    if ($('.forceOpenModal').length) {
        $('#' + $('.forceOpenModal').attr('id')).modal('show');
        // return false;
    }
    $('.reg-organizer-redirect').click(function () {
        window.showAuthForm({
            as_organizer: true,
            redirect_after: $(this).data('redirect-after')
        });
    });
    $('.reg-organizer').click(function () {
        $('#modalAuth').find('.modal-body:not(.hide)').addClass('hide');
        $('#modalAuth').find('.modal-body-reg').removeClass('hide');
        $('#modalAuth').find('.modal-body-reg .back').addClass('hide');
        $('#modalAuth').find('.modal-body-reg button[data-role="role2"]').trigger('click');
        $('#modalAuth').modal('show');
        return false;
    });
    $('#modalAuth button[data-role]').click(function () {
        let role = $(this).data('role');
        $('#role').val($(this).data('role'));
        $(this).closest('.row').find('.btn-select-active').removeClass('btn-select-active');
        $(this).addClass('btn-select-active');
        $('.social-auth-reg a').each(function () {
            var href = '', initHref = $(this).attr('href');
            if (initHref.match(/as=(role1|role2)/)) {
                href = initHref.replace(/as=(role1|role2)/g, 'as='+role);
            } else {
                if (initHref.indexOf('?') > -1) {
                    href = initHref + '&as=' + role
                } else {
                    href = initHref + '?as=' + role;
                }
            }
            $(this).attr('href', href);
        });
    });
    $('#modalAuth').on('hidden.bs.modal', function (e) {
        $('#modalAuth').find('.modal-body').addClass('hide');
        $('#modalAuth').find('.modal-body-auth').removeClass('hide');
        $('#modalAuth').find('.modal-body-reg .back').removeClass('hide');
        $('#modalAuth').find('.modal-body-reg button[data-role="role1"]').trigger('click');


        $('#modalAuth .social-auth a').each(function () {
            let href = $(this).attr('data-href')||false;
            if(href) {
                $(this).attr('href', $(this).attr('data-href'));
            }
        });
        $('#modalAuth form').each(function () {
            $(this).attr('action', $(this).attr('data-action'));
        });
    });
    $('.dropdown.dropdown-currency .dropdown-toggle,.dropdown.dropdown-language .dropdown-toggle').click(function (event) {
        $(this).dropdown('toggle');
        console.log(12);
        return false;
    });
    $(".dropdown.dropdown-currency,.dropdown.dropdown-language").hover(function () {
        $(this).find('.dropdown-toggle').dropdown('show');
    }, function () {
        $(this).find('.dropdown-toggle').dropdown('hide');
    });
    $('#advantage1').on('show.bs.modal', function (e) {
        if ($(window).width() > 1080) {
            return false;
        }
    });
    let openedTimeout = false;
    $('.js-firstAdvantageToggler').hover(function () {
        if (openedTimeout !== false) {
            clearTimeout(openedTimeout);
        }
        $('.js-firstAdvantage').addClass('opened');
    }, function () {
        openedTimeout = setTimeout(function (){
            $('.js-firstAdvantage').removeClass('opened');
        }, 300);
    });
    $('.js-firstAdvantagePop').hover(function () {
        if (openedTimeout !== false) {
            clearTimeout(openedTimeout);
        }
        $('.js-firstAdvantage').addClass('opened')
    }, function () {
        $('.js-firstAdvantage').removeClass('opened')
    });
    $('#selection').on('show.bs.modal', function (e) {
        $(this).find('.thanks').hide().next().show();
    });
    $(document).on('change', '#selection .methods input', function () {
        if ($('#selection .methods input:checked').length <= 0) {
            $('#selection form>*').not('.methods').hide();
        } else {
            $('#selection form>*').not('.methods').show();
        }
        if ($(this).val() == 'email') {
            let email_field = $('#selection .email-field');
            if ($(this).is(':checked')) {
                email_field.show().children('input').attr('required', 'required');
            } else {
                email_field.hide().children('input').removeAttr('required');
            }
        } else {
            let phone_field = $('#selection .phone-field');
            if ($('#selection .methods input:checked:not(#method-email)').length > 0) {
                phone_field.show().children('input').attr('required', 'required');
            } else {
                phone_field.hide().children('input').removeAttr('required');
            }
        }
    });
    $('[data-toggle="popover-dev"]').popover({
        'template': '<div class="popover popover-style" role="tooltip"><div class="popover-body"></div></div>',
        'placement': $(this).data('placement') ?? 'top',
        'trigger': 'focus hover click',
        'html': true
    }).on('shown.bs.popover', function (e) {
        e.stopPropagation();
        var current_popover = '#' + $(e.target).attr('aria-describedby');
        var $cur_pop = $(current_popover);
        $cur_pop.find('.popover-body').append('<button type="button" class="close"></button>');
        $cur_pop.find('.close').click(function (e) {
            $cur_pop.popover('hide');
        });
    });

  /*  $('[data-toggle="popover-with-button"]').click(function(){
        $(this).popover({
        'template': '<div class="popover popover-style" role="tooltip"><div class="popover-body"></div></div>',
        'placement': $(this).data('placement') ?? 'top',
        'trigger': 'focus hover click',
        'html': true
    }).on('shown.bs.popover', function (e) {
        e.stopPropagation();
        var current_popover = '#' + $(e.target).attr('aria-describedby');
        var $cur_pop = $(current_popover);
        $cur_pop.find('.popover-body').append('<button type="button" class="close"></button>' +
            '<a type="button" class="btn btn-primary popover-button">Зарегистрировать</a>');
        $cur_pop.find('.close').click(function (e) {
            $cur_pop.popover('hide');
        });
    }).on('hidden.bs.popover', function (e) {
            e.stopPropagation();
            var current_popover = '#' + $(e.target).attr('aria-describedby');
            var $cur_pop = $(current_popover);
            $cur_pop.find('.popover-body').html('');
        });});*/

    $('[data-toggle="popover-spec"]').popover({
        'template': '<div class="popover popover-style" role="tooltip"><div class="popover-body"></div></div>',
        'placement': $(this).data('placement') ?? 'top',
        'trigger': 'click'
    }).on('shown.bs.popover', function (e) {
        e.stopPropagation();
        var current_popover = '#' + $(e.target).attr('aria-describedby');
        var $cur_pop = $(current_popover);
        $cur_pop.find('.popover-body').append('<button type="button" class="close"></button>');
        $cur_pop.find('.close').click(function (e) {
            $cur_pop.popover('hide');
        });
    });

    $('[data-toggle="copy-links-popover-spec"]').popover({
        'template': '<div class="popover popover-style" role="tooltip"><div class="popover-body"></div></div>',
        'placement': $(this).data('placement') ?? 'top',
        'title': 'links to copy',
        'trigger': 'click',
    }).on('shown.bs.popover', function (e) {
        e.stopPropagation();
        const current_popover = '#' + $(e.target).attr('aria-describedby');
        const route = $(e.target).attr('data-route');
        const linkFlip = $(e.target).data('link-flip') !== undefined;
        const auth_id = $(e.target).attr('data-id');
        const text = $(e.target).attr('data-text');
        const tax = $(e.target).attr('data-tax');
        const selfTax = $(e.target).attr('data-selftax');
        const $cur_pop = $(current_popover);
        const firstLink = '<div class="aftercpb links-copy" style="margin-left: 0px;" data-clipboard-text="' + route + '?o=' + auth_id + '">' + text + ' ' + selfTax + '%</div>'
        const secondLink = '<div class="aftercpb links-copy" style="margin-left: 0px;" data-clipboard-text="' + route + '">' + text + ' ' + tax + '%</div>'
        if (linkFlip) {
            $cur_pop.find('.popover-body').append(secondLink + '<hr>' + firstLink + '<button type="button" class="close"></button>');
        }else{
            $cur_pop.find('.popover-body').append(firstLink + '<hr>' + secondLink + '<button type="button" class="close"></button>');
        }
        $cur_pop.find('.close, .aftercpb').click(function (e) {
            $cur_pop.popover('hide');
        });

        const links = document.querySelectorAll('.links-copy');
        new ClipboardJS(links);
    });

    $('[data-toggle="link-popover-spec"]').popover({
        'template': '<div class="popover popover-style" role="tooltip"><div class="popover-body"></div></div>',
        'placement': $(this).data('placement') ?? 'top',
        'title': 'links to copy',
        'trigger': 'click',
    }).on('shown.bs.popover', function (e) {
        e.stopPropagation();
        const current_popover = '#' + $(e.target).attr('aria-describedby');
        const route = $(e.target).data('route');
        const routeBuy = $(e.target).data('route-buy');
        const auth_id = $(e.target).data('id');
        const text = $(e.target).data('text');
        const textBuy = $(e.target).data('text-buy');
        const tax = $(e.target).data('tax');
        const selfTax = $(e.target).data('selftax');
        const $cur_pop = $(current_popover);
        const selfTaxLink = '<div class="aftercpb links-copy" style="margin-left: 0;" data-clipboard-text="' + route + '?o=' + auth_id + '">' + text + ' ' + selfTax + '%</div>'
        const taxLink = '<div class="aftercpb links-copy" style="margin-left: 0;" data-clipboard-text="' + route + '">' + text + ' ' + tax + '%</div>'
        const selfTaxBuyLink = '<div class="aftercpb links-copy" style="margin-left: 0;" data-clipboard-text="' + routeBuy + '?o=' + auth_id + '">' + textBuy + ' ' + selfTax + '%</div>'
        const taxBuyLink = '<div class="aftercpb links-copy" style="margin-left: 0;" data-clipboard-text="' + routeBuy + '">' + textBuy + ' ' + tax + '%</div>'

        $cur_pop.find('.popover-body').append(selfTaxLink + '<hr>' + selfTaxBuyLink + '<hr style="background-color: #ff575a">' + taxLink + '<hr>' + taxBuyLink + '<button type="button" class="close"></button>');
        $cur_pop.find('.close, .aftercpb').click(function (e) {
            $cur_pop.popover('hide');
        });

        const links = document.querySelectorAll('.links-copy');
        new ClipboardJS(links);
    });


    if ($('.readmore').length && $(window).width() < 767) {
        $('.readmore').each(function () {
            $(this).readmore({
                speed: 250, embedCSS: false, afterToggle: function (trigger, element, expanded) {
                    if (expanded) {
                    }
                }, lessLink: '',
                moreLink: $(this).attr('data-moreLink')
            });
        });
    }
    $.fn.datepicker.dates['ru'] = lang.datepicker;
    $('.datepicker').datepicker({
        format: 'dd.mm.yyyy'
    });

    function formatLinkSelect(state) {
        console.log(state);
        if (!state.id || state.id == '0') return state.text;
        return state.text + '<a href="#"  class="edit-curator float-right" data-options=\'' + JSON.stringify(state.options) + '\'>' + window.lang.edit + '</a>';
    }

    $('.link-select').select2({
        ajax: {
            url: $('.link-select').data('ajax'),
            dataType: 'json',
            processResults: function (data) {
                return {
                    results: $.map(data, function (item) {
                        return {
                            text: item.title,
                            id: item.id,
                            options: item.options
                        }
                    })
                };
            }
        },
        placeholder: '',
        theme: 'bootstrap4',
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true,
        formatResult: formatLinkSelect,
        formatSelection: formatLinkSelect,
        templateResult: formatLinkSelect,
        language: {
            searching: function () {
                return "...";
            }
        },
        escapeMarkup: function (m) {
            return m;
        }
    }).on('select2:open', function (e) {
        $(this).trigger('change');
    }).on('select2:select', function (e, b) {
        if ($(this).val() == 0) {
            $('#modal_curator .remove').hide();
            $('#modal_curator input[name="title"]').val('');
            $('#modal_curator textarea').val('');
            $('#upload_course_teacher_photo').next().val('');
            $('#modal_curator input[name="id"]').val(0);
            $(".course-teacher-upload").removeClass('uploaded').addClass('uploading');
            $(".course-teacher-upload div").removeAttr('style');
            $(".course-teacher-upload svg").show();
            $('#upload_course_teacher_photo').next().val('');
            $('.js-showTeacherPage').hide();
            $('#modal_curator').modal('show');
            $(this).val('').trigger('change');

            return false;
        } else {
            $('.js-showTeacherPage').show();
        }
    }).on('select2:selecting', function (e, b) {
        console.log(e);
    });
    $('#modal_curator').on('hidden.bs.modal', function (e) {
        var select = $('select[name="teacher_id"]');
        $.ajax({
            type: 'GET',
            url: select.data('ajax')
        }).then(function (data) {
            _.each(data, function (k,v) {
                if(k.id == select.val()){
                    var option = new Option(k.title, k.id, true, true);
                    select.append(option).trigger('change');
                    select.trigger({
                        type: 'select2:select',
                        params: {
                            data: k
                        }
                    });
                }
            });
        });
    });
    $(document).on('mouseup', '.edit-curator', function () {
        var data = ($(this).data('options'));
        $('#modal_curator input[name="title"]').val(data.title);
        $('#modal_curator textarea').val(data.description);
        $('#modal_curator input[name="id"]').val(data.id || 0);
        $(".course-teacher-upload div").css({'background-image': 'url(/storage/' + data.photo + ')'});
        $('#upload_course_teacher_photo').next().val(data.photo);
        $(".course-teacher-upload svg").hide();
        $('#modal_curator .remove').show();
        $('#modal_curator').modal('show');
    });

    function formatTemplate (state) {
        if (!state.id) {
            return state.text;
        }

        if ('1' === state.id) {
            // нужен для корректного отображения пустого селекта
            var onePixelImg = '<span><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="></span>';
            return $(onePixelImg);
        }

        var $state = $(
            '<span><img /></span>'
        );

        var baseUrl = "/storage/static/icons/required";
        $state.find("img").attr("src", baseUrl + "/" + state.element.value + ".svg");

        return $state;
    };

    $('#for-whom-icon-select').select2({
        templateResult: formatTemplate,
        templateSelection: formatTemplate,
        placeholder: '',
        theme: 'bootstrap4',
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true
    }).on('select2:open', function (e) {
        $(this).trigger('change');
    });

    $('#description-icon-select').select2({
        templateResult: formatTemplate,
        templateSelection: formatTemplate,
        placeholder: '',
        theme: 'bootstrap4',
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true
    }).on('select2:open', function (e) {
        $(this).trigger('change');
    });

    $('.default-select').select2({
        placeholder: '',
        theme: 'bootstrap4',
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true
    }).on('select2:open', function (e) {
        $(this).trigger('change');
    });
    $('.default-select-search').select2({
        placeholder: '',
        theme: 'bootstrap4',
        minimumResultsForSearch: 3,
        dropdownAutoWidth: true
    }).on('select2:open', function (e) {
        $(this).trigger('change');
    });

    $('.default-select-dropdown').select2({
        placeholder: '',
        theme: 'bootstrap4',
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true,
        dropdownCssClass: 'default-select-dropdown__options'
    }).on('select2:open', function (e) {
        setTimeout(function () {
            if($('.default-select-dropdown__options [aria-selected="true"]').length){
                $('.default-select-dropdown__options [aria-selected="true"]').parent().prev().addClass('selected');
                $('.default-select-dropdown__options [aria-selected="true"]').parent().addClass('active');
            }else{
                $('.default-select-dropdown__options .select2-results__group:first').addClass('selected').siblings().addClass('active');
            }
        }, 100);
    }).on('select2:select', function (e, b) {
    });
    $(document).on('click', '.select2-results__group', function() {
        $('.default-select-dropdown__options .select2-results__group').removeClass('selected');
        $('.default-select-dropdown__options .select2-results__options--nested').removeClass('active');
        $(this).siblings().addClass('active');
        $(this).addClass('selected');
    });

    $('[data-fileloader="true"]').each(function(){
        var ic=["click","touch"];
        for(let i=0;i<2;i++){
            $(this)[0].addEventListener(ic[i], function() {
                $($(this).data('retarget')).trigger('click');
            });
        }
    });

    $('[data-retarget]:not([data-fileloader="true"])').on('click touch', function () {
        $($(this).data('retarget')).trigger('click');
        return false;
    });

    $('.with-length').on('keyup', function () {
        $(this).next().find('span').text($(this).val().length);
    });

    var btns = document.querySelectorAll('.copy');
    var clipboard = new ClipboardJS(btns);
    clipboard.on('success', function(e) {
        console.info('Action:', e.action);
        console.info('Text:', e.text);
        console.info('Trigger:', e.trigger);
        console.info('Trigger:', e);
    });

    require('./webinars');
    require('./courses');
    require('./verification4');
    // require('./chat_course');
    // require('./buy_course');


        $(document).on('click', '.help-wrap', function () {
			if ($(window).width() < 767) {
				$('#help .content').html($(this).find('span').html());
				$('#help').modal('show');
			}
        });

    $(window).on( "load",function (){
        $('html').addClass('page-loaded');
    });

    const teacherPopoverEl = $('.teacher__popover:first');
    teacherPopoverEl.find('.teacherVerified').hide();

    var toogleTeacherPopover = function(){
        var teacherPopoverEl = $(this).closest('.teacher--small').find('.teacher__popover:first');
        var toogleTeacherPopoverClose = function(){
            if(teacherPopoverEl.hasClass('is-move') || !teacherPopoverEl.hasClass('is-show')) return;
            teacherPopoverEl.addClass('is-move');
            teacherPopoverEl.fadeOut(200, function(){
                teacherPopoverEl.find('.teacherVerified').hide();
                teacherPopoverEl.removeClass('is-move').removeClass('is-show');
            });
        };
        var w = window.innerWidth;
        if(w >= 500) {
            if(teacherPopoverEl.hasClass('is-move') || teacherPopoverEl.hasClass('is-show')) return;
            var parent = $(this).closest('.teacher--small');
            if(parent.data('verified') === true) teacherPopoverEl.find('.teacherVerified--verified, .teacherVerified--passport').show();
            if(parent.data('legal') === true) teacherPopoverEl.find('.teacherVerified--legal').show();
            if(parent.data('license') === true) teacherPopoverEl.find('.teacherVerified--license').show();
            if(parent.data('phone') === true) teacherPopoverEl.find('.teacherVerified--phone').show();
            if(parent.data('verified') === false) teacherPopoverEl.find('.teacherVerified--unverified').show();



            if(parent.data('online') === true){
				teacherPopoverEl.find('.online_ico').removeClass('offline');
			}else{
				teacherPopoverEl.find('.online_ico').addClass('offline');
			}
            teacherPopoverEl.find('.teacher__name').text(parent.data('name')).attr('href', parent.data('link'));
            teacherPopoverEl.find('.teacher__coursesLink').text(parent.data('courses')).attr('href', parent.data('link') + '#courses');
            teacherPopoverEl.find('.teacher__popover--head_time').text(parent.data('head_time'));
            teacherPopoverEl.find('.teacher__photo').css('background-image', 'url(' + parent.data('photo') + ')');
            teacherPopoverEl.find('.teacher__photo--link').attr('href', parent.data('link'));
            teacherPopoverEl.find('button.chat').attr('onclick', parent.data('onclick'));
        }

        teacherPopoverEl.addClass('is-move').detach().appendTo(parent).fadeIn(200, function(){
            teacherPopoverEl.removeClass('is-move').addClass('is-show');
        });

        parent.on('mouseleave', toogleTeacherPopoverClose);
        teacherPopoverEl.find('.close').on('click', toogleTeacherPopoverClose);
    };



    $('.teacher--small .teacher__photo, .teacher--small .teacher__name--block').on('mouseenter', toogleTeacherPopover);
    $('.teacher--small .teacher__photo, .teacher--small .teacher__name--block').on('mousemove', toogleTeacherPopover);

    if(window.location.hash === '#courses'){
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#courses-block").offset().top - 100
        }, 500);
    }


    let currentRating = 5;
    let tempRating = 5;
    var renderRatingBlock = function(rating){
        if(tempRating == rating) return;
        $('.add-review .rating__block span').each(function(e){
            if($(this).data('rating') > rating) $(this).removeClass('active'); else $(this).addClass('active');
        });
        $('.add-review .rating__score span').text(rating);
        tempRating = rating;
    };

    $('.add-review .rating__block span').on('mousemove', function(){renderRatingBlock($(this).data('rating'))});
    $('.add-review .rating__block span').on('mouseleave', function(){renderRatingBlock(currentRating); });
    $('.add-review .rating__block span').on('click', function(){currentRating = $(this).data('rating'); $('.add-review input[name=rating]').val(currentRating); renderRatingBlock(currentRating)});

    $('.js-window-open').click(function () {
        let href = $(this).attr('href') || $(this).attr('data-href') || '',
            target = $(this).attr('target') || $(this).attr('data-target') || 'self';

        window.open(href, target);

        return false;
    });

    $('#button_details_save').on('click', function () {
        $('#button_details_save').addClass('d-none').addClass('hidden-btn');
        $('#button_details_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_details').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_details').removeClass('d-none').addClass('showed-spinner');
    });
    $('#button_details_moderate').on('click', function () {
        $('#button_details_save').addClass('d-none').addClass('hidden-btn');
        $('#button_details_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_details').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_details').removeClass('d-none').addClass('showed-spinner');
    });

	$('[name="secret_lessons_price"]').on('change input cut copy paste',function(){
		let sec_selector = $('[name="secret_lessons_price"]');
		let secret_lessons_price = sec_selector.val().replace(/[^0-9\.]/g, '');

		if(secret_lessons_price==''){
			//скрыть
			$('.row.lesson_secret_toggle').hide();
			$('.row.lesson_secret_toggle').each(function(){
				$(this).find('input:checked').click();
			});
			sec_selector.val(secret_lessons_price);
		}else if(isNaN(parseFloat(secret_lessons_price))){
			//скрыть
			$('.row.lesson_secret_toggle').hide();
			//очистить
			sec_selector.val('');
			$('.row.lesson_secret_toggle').each(function(){
				$(this).find('input:checked').click();
			});
		}else if(secret_lessons_price<0){
			//скрыть
			$('.row.lesson_secret_toggle').hide();
			//очистить
			sec_selector.val('');
			$('.row.lesson_secret_toggle').each(function(){
				$(this).find('input:checked').click();
			});
		}else if(secret_lessons_price>=0){
			//показать
			$('.row.lesson_secret_toggle').show();
			sec_selector.val(secret_lessons_price);
		}
	});

    $('#button_prices_save').on('click', function () {
        $('#button_prices_save').addClass('d-none').addClass('hidden-btn');
        $('#button_prices_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_prices').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_prices').removeClass('d-none').addClass('showed-spinner');
    });
    $('#button_prices_moderate').on('click', function () {
        $('#button_prices_save').addClass('d-none').addClass('hidden-btn');
        $('#button_prices_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_prices').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_prices').removeClass('d-none').addClass('showed-spinner');
    });
    $('#button_desc_save').on('click', function () {
        $('#button_desc_save').addClass('d-none').addClass('hidden-btn');
        $('#button_desc_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_desc').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_desc').removeClass('d-none').addClass('showed-spinner');
    });
    $('#button_desc_moderate').on('click', function () {
        $('#button_desc_save').addClass('d-none').addClass('hidden-btn');
        $('#button_desc_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_desc').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_desc').removeClass('d-none').addClass('showed-spinner');
    });
    $('#button_lesson_save').on('click', function () {
        $('#button_lesson_save').addClass('d-none').addClass('hidden-btn');
        $('#button_lesson_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_lesson').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_lesson').removeClass('d-none').addClass('showed-spinner');
    });
    $('#button_lesson_moderate').on('click', function () {
        $('#button_lesson_save').addClass('d-none').addClass('hidden-btn');
        $('#button_lesson_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_lesson').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_lesson').removeClass('d-none').addClass('showed-spinner');
    });
    $('#button_cert_save').on('click', function () {
        $('#button_cert_save').addClass('d-none').addClass('hidden-btn');
        $('#button_cert_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_cert').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_cert').removeClass('d-none').addClass('showed-spinner');
    });
    $('#button_cert_moderate').on('click', function () {
        $('#button_cert_save').addClass('d-none').addClass('hidden-btn');
        $('#button_cert_moderate').addClass('d-none').addClass('hidden-btn');
        $('#spinner_save_cert').removeClass('d-none').addClass('showed-spinner');
        $('#spinner_moderate_cert').removeClass('d-none').addClass('showed-spinner');
    });

    $('.delete-confirm').on('click', function(event){
        event.preventDefault();
        let element = $(event.currentTarget);
        swal({
            title: window.lang.deleteHead,
            text: window.lang.deleteBody,
            icon: "warning",
            buttons: {
                cancel: {
                    text: window.lang.deleteCancel,
                    value: null,
                    visible: true,
                    className: "",
                    closeModal: true,
                },
                confirm: {
                    text: window.lang.deleteOk,
                    value: true,
                    visible: true,
                    className: "",
                    closeModal: true
                }
            },
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    window.location.href = element.attr('href');
                } else {

                }
            });
    });
    $('.delete-confirm-with-password').on('click', function (event) {
        event.preventDefault();
        let element = $(event.currentTarget), input = document.createElement('input'),
        redirect = element.data('delete-redirect')||false;
        input.type = "password";
        input.classList = 'swal-content__input';
        input.addEventListener('change',function (){swal.setActionValue(input.value);});

        swal({
            title: window.lang.deleteHead,
            text: window.lang.confirmWithPassword,
            icon: "warning",
            content: input,
            buttons: {
                cancel: {
                    text: window.lang.deleteCancel,
                    value: null,
                    visible: true,
                    className: "",
                    closeModal: true,
                },
                confirm: {
                    text: window.lang.deleteOk,
                    value: true,
                    visible: true,
                    className: "",
                    closeModal: false
                }
            },
            dangerMode: true,
        })
            .then(password => {
                if (!password || password===true) {
                    swal.stopLoading();
                    swal.close();
                    return;
                }
                $.post(element.attr('href'), {password: password}, function (response) {
                    swal.stopLoading();
                    if (response.hasOwnProperty('success') && response.success === false) {
                        swal({icon: 'error', 'text': response.message});
                        return;
                    }
                    swal.close();
                    if(redirect){
                        location.href = redirect;
                    }else {
                        location.reload();
                    }
                }).fail(function () {
                    swal.stopLoading();
                    swal.close();
                    location.reload()
                });
            });
    });

    $('.pay-confirm-with-password').on('click', function (event) {
        event.preventDefault();
        let element = $(event.currentTarget), input = document.createElement('input'),
            redirect = element.data('delete-redirect')||false;
        input.type = "password";
        input.classList = 'swal-content__input';
        input.addEventListener('change',function (){swal.setActionValue(input.value);});

        swal({
            title: window.lang.deleteHead,
            text: window.lang.confirmWithPassword,
            icon: "warning",
            content: input,
            buttons: {
                cancel: {
                    text: window.lang.deleteCancel,
                    value: null,
                    visible: true,
                    className: "",
                    closeModal: true,
                },
                confirm: {
                    text: window.lang.payOk,
                    value: true,
                    visible: true,
                    className: "",
                    closeModal: false
                }
            },
            dangerMode: true,
        })
            .then(password => {
                if (!password || password===true) {
                    swal.stopLoading();
                    swal.close();
                    return;
                }
                $.post(element.attr('href'), {password: password}, function (response) {
                    swal.stopLoading();
                    if (response.hasOwnProperty('success') && response.success === false) {
                        swal({icon: 'error', 'text': response.message});
                        return;
                    }
                    swal.close();
                    if(redirect){
                        location.href = redirect;
                    }else {
                        location.reload();
                    }
                }).fail(function () {
                    swal.stopLoading();
                    swal.close();
                    location.reload()
                });
            });
    });

    $('#country').on('change', function(){
        const bf = $('.before-text');
        const bfru = $('.before-text-ru');
        if($(this).val() === 'RU'){
            $('.ru-commission').removeClass('d-none');
            $('.other-commission').addClass('d-none');
            bf.hide();
            bfru.show();
        }else{
            $('.ru-commission').addClass('d-none');
            $('.other-commission').removeClass('d-none');
            bfru.hide();
            bf.show();

        }
    });

    $('.orders__inner_tabs.js-withdraw-to a').click(function(e){
        e.preventDefault();
        $('.orders__inner_tabs.js-withdraw-to a').removeClass('tab--active');
        $(e.currentTarget).addClass('tab--active');
        if($(e.currentTarget).hasClass('to-account')){
            $('.to-card-block').hide();
            $('.to-account-block').show();
        }else{
            $('.to-card-block').show();
            $('.to-account-block').hide();
        }
        $('.to-account-block [name=country], .to-card-block [name=country]').trigger('change');
    });

    $('.orders__tabs.withdrawn a').click(function(e){
        e.preventDefault();
        $('.orders__tabs.withdrawn a').removeClass('tab--active');
        $(e.currentTarget).addClass('tab--active');
        if($(e.currentTarget).hasClass('commissions')){
            $('.withdrawn-block').hide();
            $('.commission-block').show();
        }else{
            $('.withdrawn-block').show();
            $('.commission-block').hide();
            loadWithdrawnPage($(e.currentTarget).attr('href'));
        }
    });

    let loadWithdrawnPage = function(link){
        $.get(link, [], function(){})
            .done(function(data) {
                $('.withdrawn-block').html(data);
                $('.withdrawn-block .page-link').click(function(e){
                    e.preventDefault();
                    loadWithdrawnPage($(e.currentTarget).attr('href'));
                });
            })
            .fail(function() {
                $('.withdrawn-block').text(lang.error);
            })

    }
});

require('./categoryPicker');



$(document).on('click', '.popover-body .close', function () {

});

/*
document.addEventListener('click', function(event) {

    if ($('#currency_selector').css('display') == 'block') {
        var e=document.getElementById('currency_selector');
        if (!e.contains(event.target)) e.style.display='none';
    }

});
*/
jQuery(function($){


    $(document).mouseup(function (e){ // событие клика по веб-документу
        var div = $("#currency_selector"); // тут указываем ID элемента
        var change_currency = $('.change_currency');
        if (!div.is(e.target) // если клик был не по нашему блоку
            && div.has(e.target).length === 0 // и не по его дочерним элементам
            && change_currency.has(e.target).length === 0 // и не по ссылке открывающей список валют
        ) {
            div.hide(); // скрываем его
        }
    });

    $('.change_currency .change_currency').click(function () {
        $('.change_currency .currency_selector').toggle();
    });

    feedback_position();

    $(window).resize(function() {
        feedback_position();
    });

    // Отключаем контекстное меню у тега video
    $('video').bind('contextmenu', function() { return false;});
    $('video').on('contextmenu', function(e) {
        e.preventDefault();
        return false;
    });

});


export function feedback_position() {
    if($(window).width()>=768){
        return;
    }
    $('.course-card .teacher-and-lessons .lessons-info .price').each(function () {
        let price = $(this);
        let ratingblock = price.next('div');
        let fbpos = ratingblock.find('.rating').position();
        if (fbpos !== undefined) {
            if (price.width() > fbpos.left) {
                //ratingblock.css('height', '20px');
                $('.rating-block').css('height', '0');
                $('.rating-block').prev('.price').css('font-size','15px');
            } else {
                //ratingblock.css('height', '0');
               /* $('.rating-block').css('height', '0');
                $('.rating-block').prev('.price').css('font-size','initial');*/
            }
        }

    });
}
